import { render, staticRenderFns } from "./td-Email.vue?vue&type=template&id=3083801c"
import script from "./td-Email.vue?vue&type=script&lang=js"
export * from "./td-Email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports